// extracted by mini-css-extract-plugin
module.exports = {"button-icon":"styles_button-icon__2kacF"};